import { createSlice, createSelector } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface ExperimentsState {
    deviceId?: string;
    isEligibleForAssignment: boolean | null;
    userProperties: {
        accept?: string;
        acceptLanguage?: string;
        userAgent?: string;
    };
}

const initialState = {
    deviceId: undefined,
    isEligibleForAssignment: null,
    userProperties: {},
} satisfies ExperimentsState as ExperimentsState;

const experimentsSlice = createSlice({
    initialState,
    name: 'experiments',
    reducers: {
        experimentEligibilityReceived(state, action: PayloadAction<ExperimentsState>) {
            const {
                deviceId,
                isEligibleForAssignment,
                userProperties,
            } = action.payload;

            state.deviceId = deviceId;
            state.isEligibleForAssignment = isEligibleForAssignment;
            state.userProperties = userProperties;
        },
    },
    selectors: {
        selectExperimentEligibility: createSelector(
            (state: ExperimentsState) => state.deviceId,
            (state: ExperimentsState) => state.isEligibleForAssignment,
            (state: ExperimentsState) => state.userProperties,
            (deviceId, isEligibleForAssignment, userProperties) => ({
                deviceId,
                isEligibleForAssignment,
                userProperties,
            }),
        ),
    },
});

export type ExperimentEligibility =
    ReturnType<typeof experimentsSlice.selectors.selectExperimentEligibility>;

export const { actions, selectors } = experimentsSlice;
export const { experimentEligibilityReceived } = actions;
export default experimentsSlice.reducer;
